/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import { convertColor, convertCoordinates } from './helpers'

function processSettings(addTo, settingsData) {

  const units = addTo.app.units
  const useDining = addTo.app.useDining ? 0 : 1
  const rawScale = settingsData.locationScale
  addTo.allSeasons = settingsData.allSeasons
  addTo.sumerian.colors = settingsData.colors.reduce(
    (allColors, { name, color }) => {
      allColors[name] = convertColor(color)
      return allColors
    },
    {}
  )

  addTo.sumerian.locationScale = [rawScale, rawScale, rawScale]
  addTo.sumerian.labelOffset = convertCoordinates(settingsData.labelOffset)
  addTo.sumerian.pointerOffset = convertCoordinates(settingsData.pointerOffset)
  addTo.plotTypes = settingsData.plots.reduce((h,plot) => {
    h[plot.type] = plot
    return h
  },{})

  addTo.lawsonConversions = {
    Comfort: settingsData.lawsonConversions
      .find(r => r.units === units)
      .Comfort.slice(useDining),
    Distress: settingsData.lawsonConversions.find(r => r.units === units)
      .Distress,
  }

  return addTo
}

export default processSettings
